import React, { useEffect, useState } from "react";

/**
 * A one-shot confetti burst using DOM particles.
 * <Confetti trigger={boolean} /> — trigger flips true to fire once.
 */
export default function Confetti({ trigger }) {
  const [pieces, setPieces] = useState([]);

  useEffect(() => {
    if (!trigger) return;
    const colors = ["#1f2aff", "#ff4b2e", "#d9f871", "#0b0b0b", "#efe9dc"];
    const arr = Array.from({ length: 90 }).map((_, i) => ({
      id: `${Date.now()}-${i}`,
      x: 50 + (Math.random() - 0.5) * 40,
      y: 60,
      dx: (Math.random() - 0.5) * 140,
      dy: -Math.random() * 100 - 30,
      rot: Math.random() * 720 - 360,
      color: colors[i % colors.length],
      size: 6 + Math.random() * 10,
      shape: Math.random() > 0.5 ? "sq" : "cr",
      delay: Math.random() * 0.15,
    }));
    setPieces(arr);
    const t = setTimeout(() => setPieces([]), 2400);
    return () => clearTimeout(t);
  }, [trigger]);

  if (!pieces.length) return null;

  return (
    <div
      aria-hidden
      className="pointer-events-none fixed inset-0 z-[95]"
      data-testid="confetti-layer"
    >
      {pieces.map((p) => (
        <span
          key={p.id}
          className="absolute"
          style={{
            left: `${p.x}%`,
            top: `${p.y}%`,
            width: p.size,
            height: p.size,
            background: p.color,
            borderRadius: p.shape === "cr" ? 999 : 2,
            animation: `confetti-fall 1.8s cubic-bezier(0.2,0.7,0.2,1) ${p.delay}s forwards`,
            "--dx": `${p.dx}vw`,
            "--dy": `${p.dy}vh`,
            "--rot": `${p.rot}deg`,
          }}
        />
      ))}
      <style>{`
        @keyframes confetti-fall {
          0%   { transform: translate(0,0) rotate(0deg); opacity: 1; }
          100% { transform: translate(var(--dx), calc(var(--dy) + 100vh)) rotate(var(--rot)); opacity: 0; }
        }
      `}</style>
    </div>
  );
}
